module.exports = __webpack_public_path__ + "img/bc6f398cfa8c04fea7b8d0f7cbbba9fd.svg";